import { IUserListItem } from '@types';
import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useQuery } from '@tanstack/react-query';

//어드민 - 회원 관리 페이지: 테이블에 보여줄 리스트 데이터
async function getUserList(page: number): Promise<AxiosResponse<FetchResult<IUserListItem[]>>> {
  const response = await instance.get(`/users?page=${page}&take=10`);
  return response;
}

const useFetchUserList = (page: number) => {
  const { data: originalData, refetch } = useQuery({
    queryKey: ['get', `/users?page=${page}&take=10`],
    queryFn: () => getUserList(page),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(page)
  });

  const response = originalData?.data;

  return { response, refetch };
};

export default useFetchUserList;
